import React from "react";
import { Typography } from "@/components/Typography";
import { AccordionTabContent } from "@/components/Tabs";

import "./styles.scss";

export const FaqsPricingContainer = ({ data }) => {
  return (
    <div className="pricing-faqs__container">
      <div className="pricing-faqs__wrapper">
        <Typography Tag={"h3"}>{data.title}</Typography>

        <div className="faqs__container">
          {data.faqs.map((item, i) => (
            <AccordionTabContent
              key={i}
              item={item}
              index={i}
              customId={data.id}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
